import React from 'react';
import {Helmet} from 'react-helmet';

// import { Container } from './styles';

export default function PoliticaCookies() {
  return (
    <div className="container">
      <Helmet>
              <title>Política de Cookies da plataforma Juslabore</title>
              <meta name="description" content="Política de Cookies da plataforma Juslabore" />
            </Helmet>
      <h1 style={{ textAlign: 'center' }}>Política de Cookies</h1>
      <ol>
        <li>
          <strong>INTRODU&Ccedil;&Atilde;O</strong>
        </li>
      </ol>
      <p>
        Al&eacute;m de se preocupar com a preserva&ccedil;&atilde;o de sua
        privacidade, a{' '}
        <strong>
          <em>JUSLABORE </em>
        </strong>
        preza pela transpar&ecirc;ncia de suas atividades, buscando sempre
        deixar claro para voc&ecirc;, <strong>USU&Aacute;RIO</strong>, como a
        Plataforma atua.
      </p>
      <p>
        Dessa forma, ao aceitar os Termos de Uso e Pol&iacute;tica de
        Privacidade da{' '}
        <strong>
          <em>JUSLABORE</em>
        </strong>
        , voc&ecirc; precisa conhecer e estar de acordo com nossa
        Pol&iacute;tica de <strong>COOKIES</strong> e ferramentas de coleta
        autom&aacute;tica de dados, que visa esclarecer como tais ferramentas
        funcionam, seu prop&oacute;sito, bem como as formas de
        ativa&ccedil;&atilde;o e desativa&ccedil;&atilde;o.
      </p>
      <p>
        Assim, recomendamos veementemente que voc&ecirc; leia com
        aten&ccedil;&atilde;o a Pol&iacute;tica de <strong>COOKIES</strong> e
        ferramentas de coleta autom&aacute;tica de dados antes de se cadastrar
        ou mesmo navegar nos sites e plataforma da JUSLABORE.
      </p>
      <p>
        Por fim, frisamos que apesar de ser uma op&ccedil;&atilde;o de o{' '}
        <strong>USU&Aacute;RIO</strong> permitir ou n&atilde;o uso de{' '}
        <strong>COOKIES</strong> e outras ferramentas de coleta de dados, a
        negativa do <strong>USU&Aacute;RIO</strong> quanto a
        aplica&ccedil;&atilde;o de <strong>COOKIES</strong> e ferramentas de
        coleta autom&aacute;tica de dados PODER&Aacute; inviabilizar a
        presta&ccedil;&atilde;o de servi&ccedil;os pela JUSLABORE, de maneira
        plena e adequada.
      </p>
      <ol start="2">
        <li>
          <strong>
            O QUE S&Atilde;O COOKIES E FERRAMENTAS DE COLETA DE DADOS
          </strong>
        </li>
      </ol>
      <p>
        Antes de adentrar no m&eacute;rito sobre a utiliza&ccedil;&atilde;o dos{' '}
        <strong>COOKIES</strong> e outras tecnologias similares, achamos
        importante esclarecer o que s&atilde;o essas ferramentas.
      </p>
      <p>
        Em suma, <strong>COOKIES</strong> s&atilde;o um pequeno arquivo de dados
        (geralmente arquivos de texto criptografados) que os websites solicitam
        que o browser (navegador) do <strong>USU&Aacute;RIO</strong> armazene,
        seja no computador ou dispositivos m&oacute;veis, celulares, tablets
        etc.
      </p>
      <p>
        O principal objetivo dos <strong>COOKIES</strong> &eacute; permitir que
        o browser do <strong>USU&Aacute;RIO</strong> &ldquo;se lembre&rdquo; das
        suas a&ccedil;&otilde;es e/ou prefer&ecirc;ncias no tempo, tornado
        poss&iacute;vel que os websites que apliquem <strong>COOKIES</strong>{' '}
        forne&ccedil;am servi&ccedil;os mais r&aacute;pidos, eficientes e
        customizados ao <strong>USU&Aacute;RIO</strong>, eliminando a
        necessidade de introduzir repetidamente as mesmas
        informa&ccedil;&otilde;es.
      </p>
      <p>
        Assim, os <strong>COOKIES</strong> s&atilde;o usados, dentre outros
        fins, para identificar o <strong>USU&Aacute;RIO</strong>, armazenar e
        lembrar as prefer&ecirc;ncias personalizadas pelo{' '}
        <strong>USU&Aacute;RIO</strong>, auxiliar o{' '}
        <strong>USU&Aacute;RIO</strong> a completar tarefas sem ter que
        reinserir informa&ccedil;&otilde;es quando estiver navegando de um site
        para outro ou quanto visitar novamente a Plataforma.
      </p>
      <p>
        Outras ferramentas de coleta de dados, similares aos{' '}
        <strong>COOKIES</strong>, tamb&eacute;m s&atilde;o empregadas pela
        Plataforma JUSLABORE, <strong>COOKIES</strong> anal&iacute;ticos e de
        rastreamento objetivando coletar dados do{' '}
        <strong>USU&Aacute;RIO</strong> e do seu comportamento, para
        possibilitar o funcionamento da Plataforma.
      </p>
      <p>
        Ressaltamos, por&eacute;m, que n&atilde;o coletamos
        informa&ccedil;&otilde;es e dados do <strong>USU&Aacute;RIO</strong> que
        n&atilde;o s&atilde;o necess&aacute;rios para permitir o pleno e
        adequando funcionamento da Plataforma e presta&ccedil;&atilde;o dos
        servi&ccedil;os explicitados nos TERMOS DE USO.
      </p>
      <p>
        Al&eacute;m disso, o tratamento e uso das informa&ccedil;&otilde;es e
        dados coletados do <strong>USU&Aacute;RIO</strong> dever&atilde;o sempre
        respeitar a POL&Iacute;TICA DE PRIVACIDADE DA PLATAFORMA, por isso,
        &eacute; essencial que o <strong>USU&Aacute;RIO</strong> leia
        atentamente todas as pol&iacute;ticas da Plataforma.
      </p>
      <p>
        Vale lembrar que apesar da maioria dos browsers aceitarem{' '}
        <strong>COOKIES</strong>, o <strong>USU&Aacute;RIO</strong> sempre pode
        configurar o browser para negar a aplica&ccedil;&atilde;o de{' '}
        <strong>COOKIES</strong>, podendo deleta-los sempre que quiser.
      </p>
      <ol start="3">
        <li>
          <strong>QUE TIPO DE COOKIES UTILIZAMOS?</strong>
        </li>
      </ol>
      <p>
        Basicamente, existem dois grupos <strong>COOKIES</strong> que podem ser
        utilizados:
      </p>
      <ul>
        <li>
          <strong>COOKIES PERMANENTES</strong>: s&atilde;o{' '}
          <strong>COOKIES</strong> que ficam armazenados ao n&iacute;vel do
          browser nos seus equipamentos de acesso (PC, mobile e tablet) e que
          s&atilde;o utilizados sempre que faz uma nova visita a um dos nossos
          websites. S&atilde;o utilizados, geralmente, para direcionar a
          navega&ccedil;&atilde;o aos interesses do utilizador, permitindo-nos
          prestar um servi&ccedil;o mais personalizado.
        </li>
        <li>
          <strong>COOKIES DE SESS&Atilde;O</strong>: s&atilde;o{' '}
          <strong>COOKIES</strong> tempor&aacute;rios que permanecem no arquivo
          de <strong>COOKIES</strong> do seu browser at&eacute; sair do website.
          A informa&ccedil;&atilde;o obtida por estes <strong>COOKIES</strong>{' '}
          serve para analisar padr&otilde;es de tr&aacute;fego na web,
          permitindo-nos identificar problemas e fornecer uma melhor
          experi&ecirc;ncia de navega&ccedil;&atilde;o.
        </li>
      </ul>
      <ol start="4">
        <li>
          <strong>CATEGORIAS DE COOKIES</strong>
          <ul>
            <li>
              <strong>PREFER&Ecirc;NCIAS:</strong> Categoria de cookie que
              permite que a Plataforma JUSLABORE lembre
              informa&ccedil;&otilde;es que mudam a forma como o site se
              comporta ou &eacute; exibido, como o idioma preferido ou a
              regi&atilde;o em que o <strong>USU&Aacute;RIO</strong>{' '}
              est&aacute;. O objetivo principal desse tipo de cookie &eacute;
              melhor a experi&ecirc;ncia do <strong>USU&Aacute;RIO</strong> ao
              utilizar a PLATAFORMA menos funcional, mas n&atilde;o o impede de
              funcionar.
            </li>
            <li>
              <strong>SEGURAN&Ccedil;A</strong>: Categoria de cookie empregada
              para verificar a identidade do <strong>USU&Aacute;RIO</strong>,
              buscando evitar a utiliza&ccedil;&atilde;o fraudulenta de
              credenciais de login e proteger os dados do{' '}
              <strong>USU&Aacute;RIO</strong> de terceiros n&atilde;o
              autorizados.
            </li>
            <li>
              <strong>ANAL&Iacute;TICOS</strong>: Categoria de cookie que tem
              por objetivo permitir que propriet&aacute;rios de sites e
              aplicativos entendam e analisem como os visitantes utilizam e
              interagem com seus websites, produtos e servi&ccedil;os, por meio
              da coletar informa&ccedil;&otilde;es e estat&iacute;sticas de uso
              de relat&oacute;rios de website. Para tanto, n&atilde;o &eacute;
              preciso identificar pessoalmente o <strong>USU&Aacute;RIO</strong>
              .
            </li>
            <li>
              <strong>RASTREAMENTO:</strong> Categoria de cookie que por meio do
              armazenamento de arquivos nos dispositivos dos visitantes dos
              websites dos nossos <strong>USU&Aacute;RIO</strong>S, registra
              clicks em links, an&uacute;ncios e transa&ccedil;&otilde;es
              comerciais, como vendas e leads.
            </li>
          </ul>
        </li>
      </ol>
      <p>
        Destaca-se que o &uacute;nico prop&oacute;sito dos{' '}
        <strong>COOKIES</strong> de rastreamento aplicados pela PLATAFORMA
        &eacute; identificar uma transa&ccedil;&atilde;o efetivada por um
        afiliado atrav&eacute;s do seu link de afilia&ccedil;&atilde;o,
        permitindo assim o seu comissionamento pela transa&ccedil;&atilde;o
        concretizada. Portanto, o referido cookie n&atilde;o coleta dados de
        identifica&ccedil;&atilde;o pessoal dos visitantes, mas t&atilde;o
        somente quando e em qual dispositivo um click em um determinado link de
        afilia&ccedil;&atilde;o ocorreu, sendo essas as
        informa&ccedil;&otilde;es registradas.
      </p>
      <p>
        Nesse sentido, ressalta-se que&nbsp;&eacute; obriga&ccedil;&atilde;o dos
        PRODUTORES e AFILIADOS da PLATAFORMA JUSLABORE, ao gerar e utilizar o
        link de afilia&ccedil;&atilde;o que cont&eacute;m{' '}
        <strong>COOKIES</strong> de rastreamento, obter o consentimento livre,
        expresso e inquestion&aacute;vel dos seus{' '}
        <strong>USU&Aacute;RIO</strong>S e visitantes dos websites&nbsp;e demais
        ambientes em que os links de afilia&ccedil;&atilde;o s&atilde;o
        compartilhados e/ou disponibilizados.
      </p>
      <p>
        Ademais, os <strong>USU&Aacute;RIO</strong>S (PRODUTORES e AFILIADOS)
        ser&atilde;o integralmente respons&aacute;veis por cumprir as leis e
        normativos aplic&aacute;veis relativos a prote&ccedil;&atilde;o de dados
        pessoais, em especial LEI GERAL DE PROTE&Ccedil;&Atilde;O DE DADOS
        PESSOAIS &nbsp;OU &ldquo;LGPD&rdquo; - (LEI n&ordm; 13.709/2018),
        assumindo a obriga&ccedil;&atilde;o de obter o consentimento expresso e
        inequ&iacute;voco de seus <strong>USU&Aacute;RIO</strong>S/clientes
        relativamente a coleta, armazenamento, tratamento e processamento de
        dados pessoais, nos termos da legisla&ccedil;&atilde;o aplic&aacute;vel.
        Assim, a <strong>JUSLABORE </strong>n&atilde;o ser&aacute;
        responsabilizada por eventual falha de seus{' '}
        <strong>USU&Aacute;RIO</strong>S em cumprir tais normas, se reservando
        ao direito de suspender e/ou cancelar o contrato com{' '}
        <strong>USU&Aacute;RIO</strong>S que n&atilde;o estejam em conformidade
        com a legisla&ccedil;&atilde;o de prote&ccedil;&atilde;o de dados
        aplic&aacute;vel, bem como reter o saldo de valores a receber de tais{' '}
        <strong>USU&Aacute;RIO</strong>S como ressarcimento parcial dos danos
        que tiver experimentado, ou entregue a terceiros prejudicados, mediante
        ordem judicial.
      </p>
      <ul>
        <li>
          <strong>PUBLICIDADE</strong>: Categoria de cookie utilizada para
          tornar a adequar a publicidade ao perfil do{' '}
          <strong>USU&Aacute;RIO</strong> impactado, melhorando sua
          experi&ecirc;ncia e buscando conferir maior efetividade para
          anunciantes.
        </li>
        <li>
          <strong>PROCESSOS</strong>: Categoria de cookie empregada com o
          objetivo de melhorar o funcionamento da <strong>PLATAFORMA</strong>,
          buscando que o <strong>USU&Aacute;RIO</strong> encontre os
          servi&ccedil;os e informa&ccedil;&otilde;es esperados.
        </li>
      </ul>
      <ol start="5">
        <li>
          <strong>QUADRO GERAL DE COOKIES</strong>
        </li>
      </ol>
      <table width="100%" border="1">
        <tbody>
          <tr>
            <td width="24%">
              <p>TIPO DE COOKIES</p>
            </td>
            <td width="27%">
              <p>PORQUE USAMOS ESSE COOKIE</p>
            </td>
            <td width="26%">
              <p>COM QUE COMPARTILHAMOS E PORQUE</p>
            </td>
            <td width="21%">
              <p>POR QUANTO TEMPO ARMAZENAMOS</p>
            </td>
          </tr>
          <tr>
            <td width="24%">
              <p>Google Analytics:</p>
              <p>_ga</p>
              <p>_gid</p>
            </td>
            <td width="27%">
              <p>
                Para extrairmos informa&ccedil;&atilde;o sobre a
                utiliza&ccedil;&atilde;o da plataforma atrav&eacute;s do Google
                Analytics
              </p>
            </td>
            <td width="26%">
              <p>Sim (Google)</p>
            </td>
            <td width="21%">
              <p>Eterno</p>
            </td>
          </tr>
          <tr>
            <td width="24%">
              <p>Plataforma JUSLABORE:</p>
              <p>__amplify__</p>
              <p>lastAccess_</p>
              <p>productData</p>
              <p>productId</p>
              <p>hmLangCookie</p>
              <p>hmVlcIntegration</p>
            </td>
            <td width="27%">
              <p>
                Todos os dados salvos s&atilde;o configura&ccedil;&otilde;es do
                USU&Aacute;RIO ao utilizar a plataforma. Elas garantem o
                funcionamento do sistema de acordo com as necessidades do
                USU&Aacute;RIO.
              </p>
              <p>
                As seguintes informa&ccedil;&otilde;es s&atilde;o gerenciadas:
              </p>
              <p>Dados de cadastro do USU&Aacute;RIO</p>
              <p>Dados de acesso do USU&Aacute;RIO</p>
              <p>Dados dos produtos do USU&Aacute;RIO</p>
              <p>Idioma do USU&Aacute;RIO</p>
            </td>
            <td width="26%">
              <p>N&atilde;o</p>
            </td>
            <td width="21%">
              <p>N.A</p>
            </td>
          </tr>
          <tr>
            <td width="24%">
              <p>HotPay:</p>
              <p>lastAccess_</p>
              <p>productData</p>
              <p>__frdscr</p>
            </td>
            <td width="27%">
              <p>
                Todos os dados salvos garantem o tracking de
                afilia&ccedil;&atilde;o (descobrir quem &eacute; o
                respons&aacute;vel por indicar o produto ao comprador). Para
                isso, temos as seguintes informa&ccedil;&otilde;es salvas:
              </p>
              <p>Dados de acesso do USU&Aacute;RIO</p>
              <p>Dados do produto a ser comprado</p>
              <p>FraudScore do comprador</p>
            </td>
            <td width="26%">
              <p>N&atilde;o</p>
            </td>
            <td width="21%">
              <p>N.A</p>
            </td>
          </tr>
          <tr>
            <td width="24%">
              <p>Hot Analytics:</p>
              <p>hotid</p>
            </td>
            <td width="27%">
              <p>
                Identifica&ccedil;&atilde;o an&ocirc;nima e &uacute;nica do
                USU&Aacute;RIO para o JUSLABORE Analitycs
              </p>
              <p>
                Execu&ccedil;&atilde;o de regras de neg&oacute;cio onde &eacute;
                necess&aacute;rio saber qual o USU&Aacute;RIO, como por exemplo
                regras de comissionamento, m&eacute;tricas de analytics, perfil
                de navega&ccedil;&atilde;o do USU&Aacute;RIO
              </p>
            </td>
            <td width="26%">
              <p>N&atilde;o</p>
            </td>
            <td width="21%">
              <p>N.A</p>
            </td>
          </tr>
          <tr>
            <td width="24%">
              <p>
                <em>JUSLABORE Club</em>
              </p>
              <p>
                <em>hmClubNotification</em>
              </p>
              <p>
                <em>hmLangCookie</em>
              </p>
              <p>
                <em>isPurchase</em>
              </p>
              <p>
                <em>hmRedirect</em>
              </p>
              <p>
                <em>hmClubIntegration</em>
              </p>
            </td>
            <td width="27%">
              <p>
                Para o funcionamento correto do JUSLABORE Club, precisamos das
                seguintes informa&ccedil;&otilde;es salvas:
              </p>
              <p>
                Valida&ccedil;&atilde;o para perguntar se o USU&Aacute;RIO
                deseja receber notifica&ccedil;&otilde;es no browser
              </p>
              <p>Idioma do USU&Aacute;RIO</p>
              <p>
                Informa&ccedil;&otilde;es de produtos que podem ser comprados
              </p>
              <p>Permiss&otilde;es de acesso</p>
              <p>Dados de acesso do USU&Aacute;RIO</p>
            </td>
            <td width="26%">
              <p>N&atilde;o</p>
            </td>
            <td width="21%">
              <p>N.A</p>
            </td>
          </tr>
          <tr>
            <td width="24%">
              <p>
                <em>JUSLABORE Hub</em>
              </p>
              <p>
                <em>hmRedirect</em>
              </p>
              <p>
                <em>hmLangCookie</em>
              </p>
              <p>
                <em>hmVlcIntegration</em>
              </p>
            </td>
            <td width="27%">
              <p>
                Para o funcionamento correto do JUSLABORE Hub, precisamos das
                seguintes informa&ccedil;&otilde;es salvas:
              </p>
              <p>Dados de acesso do USU&Aacute;RIO</p>
              <p>Idioma do USU&Aacute;RIO</p>
              <p>Dados de cadastro do USU&Aacute;RIO</p>
            </td>
            <td width="26%">
              <p>N&atilde;o</p>
            </td>
            <td width="21%">
              <p>N.A</p>
            </td>
          </tr>
          <tr>
            <td width="24%">
              <p>
                <em>JUSLABORE PlayBox</em>
              </p>
              <p>
                <em>hmRedirect</em>
              </p>
              <p>
                <em>hmLangCookie</em>
              </p>
              <p>
                <em>hmClubIntegration</em>
              </p>
              <p>
                <em>JSESSIONID</em>
              </p>
            </td>
            <td width="27%">
              <p>
                Para o funcionamento correto do JUSLABOREPlayBox, precisamos das
                seguintes informa&ccedil;&otilde;es salvas:
              </p>
              <p>Dados de acesso do USU&Aacute;RIO</p>
              <p>Idioma do USU&Aacute;RIO</p>
              <p>Dados de cadastro do USU&Aacute;RIO</p>
              <p>Identifica a sess&atilde;o atual do USU&Aacute;RIO</p>
            </td>
            <td width="26%">
              <p>N&atilde;o</p>
            </td>
            <td width="21%">
              <p>N.A</p>
            </td>
          </tr>
          <tr>
            <td width="24%">
              <p>Sparkle</p>
              <p>Sparkle.User</p>
              <p>hmLangCookie</p>
              <p>fr</p>
              <p>claimId</p>
              <p>claimToken</p>
            </td>
            <td width="27%">
              <p>
                Para o funcionamento correto do Sparkle, precisamos das
                seguintes informa&ccedil;&otilde;es salvas:
              </p>
              <p>Dados de cadastro do USU&Aacute;RIO</p>
              <p>Idioma do USU&Aacute;RIO</p>
              <p>Facebook Pixel</p>
              <p>
                ID do USU&Aacute;RIO prestes a fazer "claim" de um perfil falso
              </p>
              <p>
                Token recebido da api ap&oacute;s o USU&Aacute;RIO solicitar o
                profile claim
              </p>
            </td>
            <td width="26%">
              <p>
                Sim. O pixel de facebook &eacute; compartilhado com a conta do
                aplicativo Sparkle no Facebook para manter uma
                integra&ccedil;&atilde;o entre todos os USU&Aacute;RIOS do APP e
                o Facebook.
              </p>
            </td>
            <td width="21%">
              <p>3 meses</p>
            </td>
          </tr>
        </tbody>
      </table>
      <ol start="6">
        <li>
          <strong>COMO GERIR OS COOKIES EM SEU BROWSER</strong>
        </li>
      </ol>
      <p>
        Todos os browsers (navegadores como Google Chrome, Internet Explore,
        FireFox, etc) permitem ao <strong>USU&Aacute;RIO</strong>, ao
        visitar/acessar um website, aceitar, recusar ou apagar{' '}
        <strong>COOKIES</strong>, nomeadamente por meio da sele&ccedil;&atilde;o
        das defini&ccedil;&otilde;es apropriadas no respetivo navegador. Pode-se
        configurar os <strong>COOKIES</strong> no menu
        &ldquo;op&ccedil;&otilde;es&rdquo; ou &ldquo;prefer&ecirc;ncias&rdquo;
        do seu browser.
      </p>
      <p>
        A remo&ccedil;&atilde;o ou rejei&ccedil;&atilde;o de{' '}
        <strong>COOKIES</strong> do navegador n&atilde;o afeta necessariamente
        os &ldquo;flash&rdquo; de terceiros usados junto com nossos
        servi&ccedil;os.
      </p>
      <p>
        Ressaltamos, contudo, que, ao desabilitar, parcialmente ou totalmente os{' '}
        <strong>COOKIES</strong>, a <strong>PLATAFORMA </strong>
        <strong>
          <em>JUSLABORE </em>
        </strong>
        ficar&aacute; impossibilitada de prestar os servi&ccedil;os ofertados
        por meio da PLATAFORMA, ou pode acarretar no funcionamento inadequada do
        seu website.
      </p>
      <p>&nbsp;</p>
      <ol start="7">
        <li>
          <strong>ONDE ENCONTRAR MAIS INFORMA&Ccedil;&Otilde;ES?</strong>
        </li>
      </ol>
      <p>
        Se tiver interesse em obter maiores esclarecimento
        informa&ccedil;&otilde;es sobre <strong>COOKIES</strong>, como
        gerenciar, excluir e at&eacute; mesmo como visualizar quais{' '}
        <strong>COOKIES</strong> foram configurados em seu dispositivo
        www.allaboutcookies.org e www.youronlinechoices.eu.
      </p>
      <ol start="8">
        <li>
          <strong>
            ALTERA&Ccedil;&Otilde;ES DESTA POL&Iacute;TICA DE COOKIES
          </strong>
        </li>
      </ol>
      <p>
        A{' '}
        <strong>
          <em>JUSLABORE </em>
        </strong>
        se reserva o direito de, a qualquer momento, alterar esta
        Pol&iacute;tica de <strong>COOKIES</strong> atualizando seu
        conte&uacute;do conforme as necessidades de aperfei&ccedil;oamento
        tecnol&oacute;gico ou de suas funcionalidades.
      </p>
      <p>
        Quando houver altera&ccedil;&atilde;o na Pol&iacute;tica de{' '}
        <strong>COOKIES</strong>, a{' '}
        <strong>
          <em>JUSLABORE </em>
        </strong>
        comunicar&aacute; seus <strong>USU&Aacute;RIOS</strong> por e-mail ou em
        publica&ccedil;&atilde;o em &aacute;rea de destaque na Plataforma e
        solicitar&aacute; a manifesta&ccedil;&atilde;o de sua concord&acirc;ncia
        com a Pol&iacute;tica de Privacidade alterada.
      </p>
      <p>
        Caso voc&ecirc; continue a utilizar as ferramentas oferecidas pela{' '}
        <strong>
          <em>JUSLABORE </em>
        </strong>
        ap&oacute;s a comunica&ccedil;&atilde;o da altera&ccedil;&atilde;o da
        Pol&iacute;tica de <strong>COOKIES</strong>, isto significar&aacute; e
        ser&aacute; considerado como seu consentimento inequ&iacute;voco e
        aceita&ccedil;&atilde;o irrevog&aacute;vel e irretrat&aacute;vel de
        todos os termos e condi&ccedil;&otilde;es contidos na Pol&iacute;tica
        alterada.
      </p>
      <ol start="9">
        <li>
          <strong>TEVE D&Uacute;VIDAS? FALE CONOSCO</strong>
        </li>
      </ol>
      <p>
        Caso algum ponto desta Pol&iacute;tica n&atilde;o tenha ficado claro,
        d&uacute;vidas tenham surgido ou voc&ecirc; queira fazer qualquer
        solicita&ccedil;&atilde;o com rela&ccedil;&atilde;o aos{' '}
        <strong>COOKIES</strong> e dados pessoais eventualmente tratados pela
        JUSLABORE, entre em contato conosco pelo e-mail:&nbsp;
        <a href="mailto:suporte@hotmart.com">
          <strong>suporte@juslabore.com</strong>
        </a>
        , com a seguinte frase no t&iacute;tulo &ldquo;Pol&iacute;tica de{' '}
        <strong>COOKIES</strong>&rdquo;.
      </p>
    </div>
  );
}
